export const codigoPais = [
    { value: 'CRC', display: 'CRC' },
];

export const condicionVenta = [
    { value: '01', display: 'Contado' },
    { value: '02', display: 'Crédito' },
    { value: '03', display: 'Consignación' },
    { value: '04', display: 'Apartado' },
    { value: '05', display: 'Arrendamiento con opción de compra' },
    { value: '06', display: 'Arrendamiento en función financiera' },
    { value: '07', display: 'Cobro a favor de un tercero' },
    { value: '08', display: 'Servicios prestados al Estado a crédito' },
    { value: '09', display: 'Pago del servicios prestado al Estado' },
    { value: '99', display: 'Otros' },
];

export const medioPago = [
    { value: '01', display: 'Efectivo' },
    { value: '02', display: 'Tarjeta' },
    { value: '03', display: 'Cheque' },
    { value: '04', display: 'Transferencia - Depósito Bancario' },
    { value: '05', display: 'Recaudo por Terceros' },
    { value: '06', display: 'SINPE MOVIL' },
    { value: '07', display: 'Plataforma Digital' },
    { value: '99', display: 'Otros' },
];

export const provincias = [
    { value: 2, display: 'Alajuela' },
    { value: 3, display: 'Cartago' },
    { value: 5, display: 'Guanacaste' },
    { value: 4, display: 'Heredia' },
    { value: 7, display: 'Limón' },
    { value: 6, display: 'Puntarenas' },
    { value: 1, display: 'San José' },
];

export const tarifaImpuestos = [
    {
        value: "01",
        display: "0% Tarifa",
        tarifa: 0
    },
    {
        value: "02",
        display: "1% Tarifa reducida",
        tarifa: 1
    },
    {
        value: "03",
        display: "2% Tarifa reducida",
        tarifa: 2
    },
    {
        value: "04",
        display: "4% Tarifa reducida",
        tarifa: 4
    },
    {
        value: "05",
        display: "0% Transitorio",
        tarifa: 0
    },
    {
        value: "06",
        display: "4% Transitorio",
        tarifa: 4
    },
    {
        value: "07",
        display: "8% Transitorio",
        tarifa: 8
    },
    {
        value: "08",
        display: "13% Tarifa General",
        tarifa: 13
    }
];

export const tipoDocumento = [
    { value: '01', display: 'Factura electrócnica' },
    { value: '02', display: 'Nota de débito' },
    { value: '03', display: 'Nota de crédito' },
    { value: '04', display: 'Tiquete electrócnico' },
    { value: '08', display: 'Factura de compra' },
    { value: '09', display: 'Factura de exportación' },
];

export const tipoIdentificacion = [
    { value: '01', display: 'Cédula física' },
    { value: '02', display: 'Cédula jurídica' },
    { value: '03', display: 'Dimex' },
    { value: '04', display: 'NITE' },
    { value: '05', display: 'Extranjero No Domiciliado' },
];

export const tipoMoneda = [
    { value: 'CRC', display: 'Colones' },
    { value: 'USD', display: 'Dolar USA' },
];

export const unidadMedida = [
    { value: 'Unid', display: 'Unidad' },
    { value: 'Sp', display: 'Servicios Profesionales' },
    { value: 'Al', display: 'Alquiler de uso habitacional' },
    { value: 'Alc', display: 'Alquiler de uso comercial' },
    { value: 'g', display: 'Gramo' },
    { value: 'kg', display: 'Kilogramo' },
    { value: 'L', display: 'Litro' },
    { value: 'm', display: 'Metro' },
    { value: 'Os', display: 'Otro tipo de servicios' },
    { value: 'ln', display: 'Pulgada' },
    { value: 'Spe', display: 'Servicios Personales' },
    { value: 'St', display: 'Servicios Técnicos' },
    { value: 't', display: 'Tonelada' },
];

export const tipoImpuesto = [
    { value: '00', display: 'Exento' },
    { value: '01', display: 'Impuesto al Valor Agregado' },
    { value: '02', display: 'Exonerado' },
];

export const tipoDocumentoExoneracion = [
    { value: '01', display: 'Compras autorizadas por la Dirección General de Tributación' },
    { value: '02', display: 'Ventas exentas a diplomáticos' },
    { value: '03', display: 'Autorizado por Ley Especial' },
    { value: '04', display: 'Exenciones Dirección General de Hacienda Autorización Local Genérica' },
    { value: '05', display: 'Exenciones Dirección General de Hacienda Transitorio V (servicios de ingeniería, arquitectura, topografía obra civil)'},
    { value: '06', display: 'Servicios turísticos inscritos ante el Instituto Costarricense de Turismo (ICT)' },
    { value: '07', display: 'Transitorio XVII (Recolección, Clasificación, almacenamiento de Reciclaje y reutilizable)' },
    { value: '08', display: 'Exoneración a Zona Franca' },
    { value: '09', display: 'Exoneración de servicios complementarios para la exportación articulo 11 RLIVA' },
    { value: '10', display: 'Órgano de las corporaciones municipales' },
    { value: '11', display: 'Exenciones Dirección General de Hacienda Autorización de Impuesto Local Concreta' },
    { value: '99', display: 'Otros' },
];

export const NombreInstitucionEmiteExoneracion = [
    { value: '01', display: 'Ministerio de Hacienda' },
    { value: '02', display: 'Ministerio de Relaciones Exteriores y Culto' },
    { value: '03', display: 'Ministerio de Agricultura y Ganadería' },
    { value: '04', display: 'Ministerio de Economía, Industria y Comercio' },
    { value: '05', display: 'Cruz Roja Costarricense'},
    { value: '06', display: 'Benemérito Cuerpo de Bomberos de Costa Rica' },
    { value: '07', display: 'Asociación Obras del Espíritu Santo' },
    { value: '08', display: 'Federación Cruzada Nacional de protección al Anciano (Fecrunapa)' },
    { value: '09', display: 'Escuela de Agricultura de la Región Húmeda (EARTH)' },
    { value: '10', display: 'Instituto Centroamericano de Administración de Empresas (INCAE)' },
    { value: '11', display: 'Junta de Protección Social (JPS)' },
    { value: '12', display: 'Autoridad Reguladora de los Servicios Públicos (Aresep)' },
    { value: '99', display: 'Otros' },
];

export const accionesFactura = [
    { value: '01', display: 'Factura PDF' },
    { value: '02', display: 'Factura XML' },
    { value: '03', display: 'Respuesta XML' },
    { value: '04', display: 'Reenviar Documento' },
    { value: '05', display: 'Duplicar Documento' },
    { value: '06', display: 'Nota de Crédito' },
    { value: '07', display: 'Nota de Débito' },
    { value: '08', display: 'Imprimir Factura' },
    { value: '09', display: 'Imprimir Tiquete' },
]

export const serviciosProfecionales = [
    { display: 'Al' },
    { display: 'Alc' },
    { display: 'Cm' },
    { display: 'L' },
    { display: 'Os' },
    { display: 'Sp' },
    { display: 'Spe' },
    { display: 'St' },
    { display: 'D' }
]

export const tipoDocumentoReferencia = [
    { value: '00', display: '' },
    { value: '01', display: 'Factura electrónica' },
    { value: '02', display: 'Nota de débito electrónica' },
    { value: '03', display: 'Nota de crédito electrónica' },
    { value: '04', display: 'Tiquete electrónico' },
    { value: '05', display: 'Nota de despacho' },
    { value: '06', display: 'Contrato' },
    { value: '07', display: 'Procedimiento' },
    { value: '08', display: 'Comprobante emitido en contigencia' },
    { value: '09', display: 'Devoluicion mercaderia' },
    { value: '10', display: 'Sustituye factura rechazada poir Ministerio de Hacienda' },
    { value: '11', display: 'Sustituye factura rechazada por el receptor del comprobante' },
    { value: '12', display: 'Sustituye factura de exportacion' },
    { value: '99', display: 'Otros' },
]

export const codigoDocumento = [
    { value: '00', display: '' },
    { value: '01', display: 'Anula documento de referencia' },
    { value: '02', display: 'Corrige texto de documento de referencia' },
    { value: '03', display: 'Corrige monto' },
    { value: '04', display: 'Referencia a otro documento' },
    { value: '05', display: 'Sustituye comprobante provisional por contigencia' },
    { value: '99', display: 'Otros' },
]
export const estadoConfirmacion = [
    { value: '0', display: ' Aceptado' },
    { value: 'Aceptado', display: ' Aceptado' },
    { value: 'Rechazado', display: ' Rechazado' },
    { value: '1', display: ' Enviado' },
    { value: '2', display: ' Rechazado' },
    { value: '3', display: ' Enviado' },
    { value: '4', display: ' Enviado' },
    { value: '5', display: ' Error de Envio' },
    { value: '6', display: ' El documento no presenta receptor ' },
    { value: '7', display: ' La cedula del receptor no corresponde al usuario' },
    { value: '8', display: ' El documento no esta firmado' },
];

export const tipoReporte = [
    { value: '1', display: 'Enviadas' },
    { value: '2', display: 'Recibidas/Confirmadas' },
    { value: '3', display: 'Resumen Impuesto Neto' },
];

export const meses = [
    { value: '1', display: 'Enero' },
    { value: '2', display: 'Febrero' },
    { value: '3', display: 'Marzo' },
    { value: '4', display: 'Abril' },
    { value: '5', display: 'Mayo' },
    { value: '6', display: 'Junio' },
    { value: '7', display: 'Julio' },
    { value: '8', display: 'Agosto' },
    { value: '9', display: 'Septiembre' },
    { value: '10', display: 'Octubre' },
    { value: '11', display: 'Noviembre' },
    { value: '12', display: 'Diciembre' },
];

